package com.example.mystybag.core.expected

expect class Activity

lateinit var sharedActivity: Activity

val isSharedActivityInitialized: Boolean
    get() = ::sharedActivity.isInitialized